import React, {useEffect, useState, useRef} from 'react';
import Footer from '../../../shared/Footer';
import "./projects-detail-page.css";
import { Fade } from 'react-reveal';
import { Waypoint } from 'react-waypoint';
import semmering0 from '../../../images/projects/Semmering/semmeringt.jpg';
import semmering1 from '../../../images/projects/Semmering/semmering1.jpg';
import semmering2 from '../../../images/projects/Semmering/semmering2.jpg';
import semmering3 from '../../../images/projects/Semmering/semmering3.jpg';
import semmering6 from '../../../images/projects/Semmering/semmering6.jpg';
import semmering7 from '../../../images/projects/Semmering/semmering7.jpg';
import semmering12 from '../../../images/projects/Semmering/semmering12.jpg';
import semmering9 from '../../../images/projects/Semmering/semmering9.jpg';
import semmering10 from '../../../images/projects/Semmering/semmering10.jpg';
import semmering11 from '../../../images/projects/Semmering/semmering11.jpg';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import {responsive} from './Carousel.js';

export default function Semmering() {
    document.title = "Semmering - kyska.sk";

    const [animationTriggered, setAnimationTriggered] = useState(false);

    const handleWaypointEnter = () => {
      setAnimationTriggered(true);
    };

    const carouselRef = useRef(null);

    const handlePrevClick = (event) => {
        event.preventDefault();
        carouselRef.current.previous();
    };

    const handleNextClick = (event) => {
        event.preventDefault();
        carouselRef.current.next();
    };

    return (
        <div>
            <Waypoint onEnter={handleWaypointEnter}>
            <Fade duration={1000}>
                <h3 className="top-heading"></h3>

                <div className='carousel-container'>
                    <Carousel
                        responsive={responsive}
                        infinite={true}
                        draggable={false}
                        ref={carouselRef}
                        autoPlay={10000}
                        arrows={false}
                        >

                        <img
                            className="img-fluid"
                            src={semmering0}
                        />

                        <img
                            className="img-fluid"
                            src={semmering1}
                        />
                        
                        <img
                            className="img-fluid"
                            src={semmering2}
                        />
                    
                        <img
                            className="img-fluid"
                            src={semmering3}
                        />

                        <img
                            className="img-fluid"
                            src={semmering6}
                        />

                        <img
                            className="img-fluid"
                            src={semmering7}
                        />

                        <img
                            className="img-fluid"
                            src={semmering9}
                        />

                        <img
                            className="img-fluid"
                            src={semmering10}
                        />

                        <img
                            className="img-fluid"
                            src={semmering11}
                        />

                        <img
                            className="img-fluid"
                            src={semmering12}
                        />
                    </Carousel>
                </div>

                <div className="carousel-controls">
                    <a
                        className="carousel-control-prev-a"
                        href="#carousel"
                        role="button"
                        onClick={handlePrevClick}
                    >
                        <span className="carousel-control-prev-icon" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" class="bi bi-chevron-compact-left" viewBox="0 0 16 16" preserveAspectRatio="none">
                                <path fill-rule="evenodd" d="M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223z"/>
                            </svg>
                        </span>
                    </a>

                    <a
                        className="carousel-control-next-a"
                        href="#carousel"
                        role="button"
                        onClick={handleNextClick}
                    >
                        <span className="carousel-control-next-icon" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" class="bi bi-chevron-compact-right" viewBox="0 0 16 16" preserveAspectRatio="none">
                                <path fill-rule="evenodd" d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671z"/>
                            </svg>
                        </span>
                    </a>
                </div>

                
                <h3 className='detail-heading'>Semmering</h3>
                <hr className='detail-hr'/>
                <p>Dlhodobú spoluprácu v rakúskom prostredí sme zúročili zaujímavým projektom bytového domu v atraktívnej lokalite Semmering. Objekt sa nachádza v chránenej prírodnej oblasti. Atraktívna poloha a prostredie viedlo investora k rozhodnutiu zhodnotiť nehnuteľnosť. Forma nového zastavania a funkcia bola priamo určená regulatívmi územného plánu. Jedná sa o dva objekty Haus 1 a Haus 2. Objekty formou a výrazom rešpektujú miestne prostredie. Realizácia bude vo vyššom štandarde.</p>
                <br></br>

                <hr className="project-detail-hr"></hr>
                <div className="project-detail-table" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>Rok realizácie</div>
                    <div>V príprave</div>
                </div>
                <hr className="project-detail-hr"></hr>

                <div className="project-detail-table" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>Výkon</div>
                    <div>Projekčné práce v spolupráci s ateliérom Ing. Bmst. Alex Niessl</div>
                </div>
                <hr className="project-detail-hr"></hr>

                <div className="project-detail-table" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>Stavebník</div>
                    <div>Právnická osoba</div>
                </div>
                <hr className="project-detail-hr"></hr>

                <div className="project-detail-table" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>Lokalita</div>
                    <div>Rakúsko – Štajersko, Semmering</div>
                </div>
                <hr className="project-detail-hr"></hr>
                                
            </Fade>
            </Waypoint>

            <Footer />
        </div>
    );
}

